var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "no-body": "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("b-card-img", {
                staticStyle: { height: "500px" },
                attrs: { src: _vm.post.media_url, alt: "Image" },
              }),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-card-body",
                { staticClass: "px-0" },
                [
                  _c(
                    "b-row",
                    { staticClass: "mb-1" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "d-flex", attrs: { cols: "6" } },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "HeartIcon", size: "20" },
                          }),
                          _c("b-card-text", [
                            _vm._v(
                              _vm._s(_vm.post.like_count) +
                                " " +
                                _vm._s(
                                  _vm.post.like_count === 1 ||
                                    _vm.post.like_count === 0
                                    ? "Like"
                                    : "Likes"
                                )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { staticClass: "d-flex", attrs: { cols: "6" } },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "MessageCircleIcon", size: "20" },
                          }),
                          _c("b-card-text", [
                            _vm._v(
                              _vm._s(_vm.post.comments_count) +
                                " " +
                                _vm._s(
                                  _vm.post.comments_count === 1 ||
                                    _vm.post.comments_count === 0
                                    ? "Comment"
                                    : "Comments"
                                )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.post.caption != null
                    ? _c("b-card-text", { staticClass: "caption" }, [
                        _c("b", [_vm._v(_vm._s(_vm.post.username) + ":")]),
                        _vm._v(" " + _vm._s(_vm.post.caption)),
                      ])
                    : _c("b-card-text", { staticClass: "caption" }, [
                        _vm._v("No Caption"),
                      ]),
                  _c("hr"),
                  _vm.post.comments_count > 0
                    ? _c("b-card-text", { staticClass: "comments" }, [
                        _c("b", [
                          _vm._v(_vm._s(_vm.post.comments.data[0].username)),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm.post.comments.data[0].text) + " "
                        ),
                      ])
                    : _c("b-card-text", { staticClass: "comments" }, [
                        _vm._v("No comments yet"),
                      ]),
                ],
                1
              ),
              _c(
                "b-card-footer",
                { staticClass: "px-0 border-0" },
                [
                  _c(
                    "b-row",
                    { staticClass: "justify-content-between" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: {
                                variant: "primary",
                                href: _vm.post.permalink,
                                target: "_blank",
                              },
                            },
                            [_vm._v("View Post")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "w-100",
                              attrs: { variant: "danger" },
                            },
                            [_vm._v("Delete")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }